import { BaseEventTarget } from './event.base';

export const ViewEventTarget = BaseEventTarget;
export type ViewEventTarget = BaseEventTarget;

